// extracted by mini-css-extract-plugin
module.exports =  {"avatar":"_02712f2b3b--avatar--ceW9Q","clickable":"_02712f2b3b--clickable--jjxbB","company":"_02712f2b3b--company--MXKHY"};